module.exports = require('./src/google-maps-api-loader.js');



// WEBPACK FOOTER //
// ./client/src/vendor/google-maps-api-loader/index.js